// Consumer tracker personas, mirrored from the mobile app's persona_service.dart.
// The API only knows asset_type_id; the persona (icon, color, label) is a
// client-side presentation layer. Asset type ids 47-54 are the consumer
// personas seeded on the backend. Keep this in sync with the mobile app.

export const PERSONAS = [
    {id: "kid", assetTypeId: 47, label: "My child", short: "Child", icon: "mdi-human-child", color: "#EC4899"},
    {id: "senior", assetTypeId: 48, label: "Senior family member", short: "Senior", icon: "mdi-human-cane", color: "#EF4444"},
    {id: "pet", assetTypeId: 49, label: "My pet", short: "Pet", icon: "mdi-paw", color: "#F97316"},
    {id: "vehicle", assetTypeId: 50, label: "A vehicle", short: "Vehicle", icon: "mdi-car", color: "#3B82F6"},
    {id: "luggage", assetTypeId: 51, label: "Luggage", short: "Luggage", icon: "mdi-bag-suitcase", color: "#8B5CF6"},
    {id: "bike", assetTypeId: 52, label: "Bike", short: "Bike", icon: "mdi-bike", color: "#10B981"},
    {id: "equipment", assetTypeId: 53, label: "Equipment", short: "Equipment", icon: "mdi-tools", color: "#6366F1"},
    {id: "other", assetTypeId: 54, label: "Something else", short: "Other", icon: "mdi-package-variant", color: "#6B7280"},
];

import {useAssetTypeStore} from "@/stores/assetTypeStore";

// Normalize a backend consumer asset-type row into the persona shape the UI
// expects (icon/color/short/label/kind).
function fromCatalog(c) {
    return {
        id: c.slug,
        assetTypeId: c.id,
        label: c.display_name || c.name,
        short: c.short_name || c.display_name || c.name,
        icon: c.app_icon,
        color: c.bg_color,
        kind: c.subject_kind,
    };
}

export function personaByAssetTypeId(assetTypeId) {
    if (assetTypeId === null || assetTypeId === undefined) return null;
    const id = Number(assetTypeId);
    // Prefer the table-driven catalog; fall back to the hardcoded list before
    // it has loaded (or if the store/pinia isn't available yet).
    try {
        const c = useAssetTypeStore().byAssetTypeId(id);
        if (c && c.app_icon) return fromCatalog(c);
    } catch (e) {
        // pinia not ready - use the fallback below
    }
    return PERSONAS.find((p) => p.assetTypeId === id) ?? null;
}

export function personaById(id) {
    return PERSONAS.find((p) => p.id === id) ?? null;
}

// The list of consumer personas to show in the picker. Table-driven when the
// catalog has loaded (so new types like Phone/Boat appear), else the hardcoded
// eight as a fallback.
export function consumerPersonas() {
    try {
        const list = useAssetTypeStore().consumer;
        if (list && list.length) return list.filter((c) => c.app_icon).map(fromCatalog);
    } catch (e) {
        // pinia not ready
    }
    return PERSONAS;
}
